module.exports = __webpack_public_path__ + "static/media/sort_icon_desc.aeb71846.svg";